module.exports = require("redux-immutable");


//////////////////
// WEBPACK FOOTER
// external "redux-immutable"
// module id = 379
// module chunks = 0